import { JsonObject } from 'json2typescript';
import { ServicesModelInterface } from '../interfaces/servicesmodel.interface';
import { SectionToComplete } from './sectionstocomplete.model';

@JsonObject('ServicesModelModel')
export class ServicesModelModel implements ServicesModelInterface {
  ServiceModelCode?: string;
  ServiceModelName?: string;
  ServiceModelDescription?: string;
  Image?: string;
  IsAccessible?: string;
  SectionsToComplete?: SectionToComplete[];
  Conflict?:string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
